import axios from 'axios'
// import qs from 'qs'
import rootApi from '@/rootUrl'
const root = rootApi //接口API
// const root = "https://stuapi.kidcastle.cn"
const url = {
  getUserMenu: `${root}/Base/getUserMenu`, // 用户登录获取个性化菜单明细
  getGoldTotaling: `${root}/Student/getGoldTotaling`, // 学生金币总数获取
  getOneStudent:root+"/Student/getOneStudent",//个人中心->获取单个孩子信息--zjb
}
const common = {
  getUserMenu(params :any) {
    return axios.get(url.getUserMenu, { params })
  },
  getGoldTotaling(params :any) {
    return axios.get(url.getGoldTotaling, { params })
  },
  getOneStudent(params :any) {
    return axios.get(url.getOneStudent, { params })
  },
}

export default common;